// 9fbef606107a605d69c0edbcd8029e5d

const drawSquare = (ctx, size, colors) => {
  ctx.fillStyle = colors;
  ctx.fillRect(0, 0, size, size);
};

export default drawSquare;
